// extracted by mini-css-extract-plugin
module.exports = {"root":"_861c4d","summaryWrapper":"_fde5c8","summaryHeadline":"_46b4ef","circularProgress":"_f74127","summaryIcon":"_a999a1","goodRecommendation":"_f18814"};